<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>{{ $t('Coupon.list.Edit Coupon Details') }}</h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-5 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Coupon.list.Coupon Title') }}</label>
                            <InputText :class="`${error.title ? 'p-invalid' : ''}`" type="text" :placeholder="$t('Banner.list.title')" id="title2" v-model="title"  maxlength="65"></InputText>
                            <div class="text-red">{{ error.title }}</div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-5 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Coupon.list.coupon Description') }}</label>
                            <Textarea maxlength="240" :class="`${error.link ? 'p-invalid' : ''}`" type="text" placeholder="쿠폰 설명" :autoResize="true" rows="5" cols="30" v-model="couponCode"></Textarea>
                            <div class="text-red">{{ error.link }}</div>
                        </div>
                    </div>
                    <!-- <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-field p-col-12 p-md-5">
                            <label for="pass">{{ $t('Start Date') }}</label>
                            <Calendar :class="`${error.calendarValue ? 'p-invalid' : ''}`" :showIcon="true" :showButtonBar="true" v-model="start_date" dateFormat="yy.mm.dd" :showTime="true" hourFormat="12" :placeholder="$t('search.placeholder.date')"></Calendar>
                            <div class="text-red">{{ error.calendarValue }}</div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-field p-col-12 p-md-5">
                            <label for="pass">{{ $t('End Date') }}</label>
                            <Calendar :class="`${error.calendarValue ? 'p-invalid' : ''}`" :showIcon="true" :showButtonBar="true" v-model="end_date" dateFormat="yy.mm.dd" :showTime="true" hourFormat="12" :placeholder="$t('search.placeholder.date')"></Calendar>
                            <div class="text-red">{{ error.calendarValue }}</div>
                        </div>
                    </div> -->
                    <div class="p-col-12 p-mb-2 p-lg-5 p-mb-lg-0 p-field">
                        <label for="exposure">{{ $t('Coupon.list.Status') }}</label>
                        <div class="p-field p-col-12 p-md-3">
                            <InputSwitch v-model="status" />
                            <!-- <div class="text-red">{{ error.title }}</div> -->
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-5 p-mb-lg-0 p-field">
                            <label for="subtitle2">
                                {{ $t('Coupon.list.Upload Coupon Image') }}
                                <span class="img-info">(File Type jpg,jpeg,png )</span>
                            </label>
                            <div :class="`${error.file ? 'custom-select-invalid' : 'custom-select'}`">
                                <span v-if="!fileName">파일 선택</span>
                                <span v-else>{{ fileName }}</span>
                                <input type="file" class="select-file" v-on:change="onFileChange" />
                                <Button :label="$t('button.select_file')" class="SelectBtn n-wrap" />
                            </div>
                            <div class="text-red">{{ error.file }}</div>
                            <div class="text-red" v-show="render1">{{ $t('validation.invalidFile') }}</div>
                            <Image :src="image" :alt="fileName1" class="product-image" width="137" height="85" preview />

                        </div>
                    </div>
                </div>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center">
                <div>
                    <Button :label="$t('Coupon.list.Back')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="$router.go(-1)"></Button>
                    <Button :label="$t('Coupon.list.Confirm')" icon="pi pi-check" iconPos="left" class="p-button p-button-sm p-mr-2 p-mb-2" @click="addCoupon"></Button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';
import CouponService from '../../service/API/CouponService';
// import validateCreateBanner from '../../validations/banner/validateCreateBanner';
export default {
    name: 'addCoupon',
    // props: ['dog', 'image'],
    data() {
        return {
            render1: false,
            render2: false,
            dropdownValues: [
                { name: 'active', code: '활성' },
                { name: 'inactive', code: '비활성' },
            ],
            dropdownValueTypes: [
                { name: 'nft', code: 'NFT' },
                { name: 'card_news', code: 'Card News' },
                { name: 'media_press', code: 'Media press' },
                { name: 'de_fi_services', code: 'De-Fi Services' },
            ],
            dropdownValue: '활동적인',
            dropdownValueType: null,
            title: '',
            couponCode: '',
            status: '',
            start_date: '',
            end_date: '',
            subtitle: null,
            link: '',
            files: null,
            filesName: '',
            file: '',
            image: '',
            fileName: '',
            fileExtension: '',
            filesExtension: '',
            formData: new FormData(),
            error: {},
        };
    },
    created() {
        this.couponService = new CouponService();
    },
    mounted() {
        this.couponService.couponDetails(this.$route.params.id).then((data) => {
            console.log(data);
            this.title = data[0].coupon_title;
            this.couponCode = data[0].coupon_description;
            // this.start_date = this.formatDate(data[0].start_date);
            // this.end_date = this.formatDate(data[0].end_date);
            this.status = data[0].status == 'active' ? true : false;
            this.image = data[0].image;
            this.fileName=data[0].image;
        });
    },
    methods: {
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            var hr=date.getHours();
            var min=date.getMinutes();
            var sec=date.getSeconds();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            if (sec < 10) {
                sec = '0' + sec;
            }
            return (value =`${yyyy}-${mm}-${dd} ${hr}:${min}:${sec}`);
        },
        reinitialize() {
            (this.dropdownValue = null), (this.dropdownValueType = null), (this.title = null), (this.subtitle = null), (this.link = null), (this.fileName = null), (this.file = {});
        },
        onFileChange(e) {
            this.formData.delete('file');
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.file = files[0];
            var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (!allowedExtensions.exec(this.file.name)) {
                this.render1 = true;
                return false;
            } else {
                this.render1 = false;
                this.fileName = this.file.name;
                this.formData.append('image', files[0]);
            }
            this.fileExtension = this.fileName.replace(/^.*\./, '');
            console.log(this.fileName);
        },
        addCoupon() {
            // let vcheckData = {
            //     title: this.title,
            //     state: this.dropdownValue == null ? '' : 'something',
            //     type: this.dropdownValueType == null ? '' : 'something',
            //     link: this.link,
            //     file: this.fileName == '' ? '' : 'something',
            // };
            // this.formData.delete('title');
            // this.formData.delete('link');
            // this.formData.delete('status');
            // this.formData.delete('type');
            // const { isInvalid, error } = validateCreateBanner(vcheckData);
            // if (isInvalid) {
            //     this.error = error;
            //     console.log(error);
            // } else {
            // console.log(this.file);
            this.formData.append('coupon_description', this.couponCode);
            this.formData.append('coupon_title', this.title);
            // this.formData.append('start_date', this.formatDate(this.start_date));
            // this.formData.append('end_date', this.formatDate(this.end_date));
            this.formData.append('status', this.status==true ?'active':'inactive');
            console.log(this.formData);
            return axios.patch(`/coupon/${this.$route.params.id}`, this.formData).then(() => {
                this.$toast.add({ severity: 'info', summary: '확인.', detail: '성공적으로 등록되었습니다.', life: 3000 });
                this.$router.push({ name: 'couponList' });
            });
            // }
        },
    },
};
</script>

<style scoped>
.img-info {
    font-size: 11px;
    font-weight: 400;
    color: rgb(48, 48, 48);
}
.custom-select {
    position: relative;
    border: 1px solid #cecece;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}
.custom-select-invalid {
    position: relative;
    border: 1px solid red;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}
.select-file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0%;
    z-index: 5;
    opacity: 0;
}
.SelectBtn {
    max-width: 100px;
}
.custom-select span {
    max-width: 140px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
